import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from 'src/shared/shared.module';
import { components } from 'src/core/components';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { interceptors } from 'src/core/interceptors';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe, registerLocaleData } from '@angular/common';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

/** config angular i18n **/
import localEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';
import { NZ_I18N, ar_EG, en_US } from 'ng-zorro-antd/i18n';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';

registerLocaleData(localEn);
registerLocaleData(localeAr);

@NgModule({
    declarations: [AppComponent, ...components],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        NzDropDownModule,
        NzIconModule,
        NzMenuModule,
        TranslateModule.forRoot(),
    ],
    providers: [
        ...interceptors,
        {
            provide: NZ_I18N,
            deps: [TranslateService],
            useFactory: (translate: TranslateService) =>
                translate.currentLang === 'ar' ? ar_EG : en_US,
        },
        {
            provide: LOCALE_ID,
            deps: [TranslateService],
            useFactory: (translate: TranslateService) =>
                translate.currentLang === 'ar' ? 'ar' : 'en',
        },
        DatePipe,
        provideTranslateHttpLoader({
            prefix: '#/assets/i18n/',
            suffix: '.json',
        }),
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
